





























































































































































import { Component, Emit, Watch, Vue } from 'vue-property-decorator';
import noUiSlider from 'nouislider';
import { Cluster } from '@/interfaces/Cluster';
import { VirtualMachineResources } from '@/interfaces/VirtualMachineResources';
import { AdditionalDiskData } from '@/interfaces/AdditionalDiskData';
import { SubResourceData } from '@/interfaces/SubResourceData';
import { limitsService } from '@/services/LimitsService';

@Component({
  props: ['operatingSystem', 'version', 'diskTypes'],
})
export default class ClusterParametersSelector extends Vue {
  workspaceId = 0;
  regionId = 0;
  selectedCluster: Cluster | null = null;
  isTabActive = -1;
  selectedCpu = 0;
  selectedRam = 0;
  selectedPrimaryDisk = 0;
  selectedPrimaryDiskType = 'HDD';
  maxAdditionalDisks = 0;
  newAdditionalDiskId = 0;
  additionalDisks: AdditionalDiskData[] = [];
  resources: VirtualMachineResources | null = null;
  limits: any = {};
  currentUsage: any = {};
  rest: any = {};
  additionalDisksStorage: number = 0;
  locale: string = '';

  @Watch('$props.version')
  onVersionChanged(val: any) {
    if (val && val.clusters) {
      this.clusterSelected(val.clusters[0], 0);
    }
  }

  @Watch('selectedCpu')
  @Watch('selectedRam')
  @Watch('selectedPrimaryDisk')
  @Watch('selectedPrimaryDiskType')
  @Watch('additionalDisks', { immediate: true, deep: true })
  onParametersChanged() {
    this.parametersChanged();
  }

  @Emit()
  parametersChanged() {
    return {
      profile: this.selectedCluster,
      cpu: this.selectedCpu,
      ram: this.selectedRam,
      primaryDisk: this.selectedPrimaryDisk,
      primaryDiskType: this.selectedPrimaryDiskType,
      additionalDisks: this.additionalDisks,
      rest: this.rest,
    };
  }

  @Emit()
  clusterSelected(cluster: Cluster, index: number) {
    this.selectedCluster = cluster;
    this.resources = this.selectedCluster.resources;
    this.isTabActive = index;
    this.additionalDisks = [];
    this.newAdditionalDiskId = 0;
    this.maxAdditionalDisks = cluster['max_additional_disks'];
    this.initSliders();
    return cluster;
  }

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.locale = (window as any).VueGlobal.$i18n.locale || localStorage.getItem('locale');
    this.getLimits();
  }

  updateSliderValue(ref: any, value: number) {
    const slider = (this.$refs[ref] as any)[0] || (this.$refs[ref] as any);
    if (slider.noUiSlider) {
      slider.noUiSlider.set(value);
    }
  }

  updateCpu() {
    this.updateSliderValue('cpuSlider', this.selectedCpu);
  }

  updateRam() {
    this.updateSliderValue('ramSlider', this.selectedRam);
  }

  updateDisk() {
    this.updateSliderValue('primaryDiskSlider', this.selectedPrimaryDisk);
  }

  sumAdditionalDisksForLimits() {
    this.additionalDisksStorage = 0;
    for (let additionalDisk of this.additionalDisks) {
      this.additionalDisksStorage += parseInt(additionalDisk.value as string, 10);
    }
  }

  updateAdditionalDisk(index: number) {
    this.updateSliderValue(`additionalDisk${index + 1}`, this.additionalDisks[index].value as number);
    this.sumAdditionalDisksForLimits();
  }

  getLimits() {
    limitsService.getLimits(this.workspaceId, this.regionId).then((data: any) => {
      this.limits = data;
      limitsService.getCurrentUsage(this.workspaceId, this.regionId).then((data: any) => {
        this.currentUsage = data;
        ['cpu_cores', 'ram', 'storage', 'public_networks'].map(item => {
          this.rest[item] = this.limits[item] - this.currentUsage[item];
        });
      });
    });
  }

  createSlider(ref: any, options: SubResourceData) {
    const slider = (this.$refs[ref] as any)[0] || (this.$refs[ref] as any);
    if (slider.noUiSlider) {
      slider.noUiSlider.updateOptions({
        start: [options.min],
        range: { min: options.min, max: options.max },
      });
    } else {
      noUiSlider.create(slider, {
        start: [options.min],
        connect: [true, false],
        range: { min: options.min, max: options.max },
        step: 1,
      });
    }
    return slider.noUiSlider;
  }

  createDynamicSlider(id: number, index: number) {
    this.$nextTick().then(() => {
      if (!this.selectedCluster) {
        return;
      }
      const resources = this.selectedCluster.resources;
      this.createSlider(`additionalDisk${id}`, resources.additional_disk).on('update', (value: any) => {
        this.additionalDisks[index].value = parseInt(value, 10);
        this.sumAdditionalDisksForLimits();
      });
    });
  }

  initSliders() {
    this.$nextTick().then(() => {
      if (!this.selectedCluster) {
        return;
      }
      const resources = this.selectedCluster.resources;
      this.createSlider('cpuSlider', resources.cpu).on('update', (value: any) => {
        this.selectedCpu = parseInt(value, 10);
      });
      this.createSlider('ramSlider', resources.ram).on('update', (value: any) => {
        this.selectedRam = parseInt(value, 10);
      });
      this.createSlider('primaryDiskSlider', resources.primary_disk).on('update', (value: any) => {
        this.selectedPrimaryDisk = parseInt(value, 10);
      });
    });
  }

  addAdditionalDisk() {
    this.newAdditionalDiskId += 1;
    this.additionalDisks.push({ id: this.newAdditionalDiskId, value: 0, diskType: 'HDD' });
    this.createDynamicSlider(this.newAdditionalDiskId, this.additionalDisks.length - 1);
  }

  removeAdditionalDisk(index: number) {
    this.additionalDisks.splice(index, 1);
    this.sumAdditionalDisksForLimits();
  }
}
